<template>
  <div class="field-preview">
    <div class="field-label">
      <span>{{ field.label }}</span>
      <v-chip x-small color="primary" class="ml-2" v-if="field.required">Required</v-chip>
    </div>

    <v-text-field
      v-model.number="value"
      type="number"
      :placeholder="field.hint || 'Enter number...'"
      outlined
      dense
      :rules="fieldRules"
      :min="field.minValue"
      :max="field.maxValue"
      :step="field.stepValue || 1"
      class="preview-input"
    ></v-text-field>

    <div class="field-description" v-if="field.description">
      <v-icon small color="grey">mdi-information-outline</v-icon>
      <span>{{ field.description }}</span>
    </div>

    <div class="field-constraints mt-1" v-if="hasConstraints">
      <div v-if="field.minValue !== undefined" class="constraint">
        <v-icon x-small color="grey">mdi-chevron-right</v-icon>
        Min value: {{ field.minValue }}
      </div>
      <div v-if="field.maxValue !== undefined" class="constraint">
        <v-icon x-small color="grey">mdi-chevron-right</v-icon>
        Max value: {{ field.maxValue }}
      </div>
      <div v-if="field.stepValue !== undefined" class="constraint">
        <v-icon x-small color="grey">mdi-chevron-right</v-icon>
        Step: {{ field.stepValue }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NumberFieldPreview',
  props: {
    field: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      value: null
    }
  },
  computed: {
    hasConstraints() {
      return this.field.minValue !== undefined || this.field.maxValue !== undefined || this.field.stepValue !== undefined;
    },
    fieldRules() {
      const rules = [];

      // Required validation
      if (this.field.required) {
        rules.push(v => (v !== null && v !== undefined) || 'This field is required');
      }

      // Min value validation
      if (this.field.minValue !== undefined) {
        rules.push(v => !v || v >= this.field.minValue || `Minimum value is ${this.field.minValue}`);
      }

      // Max value validation
      if (this.field.maxValue !== undefined) {
        rules.push(v => !v || v <= this.field.maxValue || `Maximum value is ${this.field.maxValue}`);
      }

      return rules;
    }
  }
}
</script>

<style scoped>
.field-preview {
  display: flex;
  flex-direction: column;
}

.field-label {
  font-weight: 500;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}

.field-description {
  margin-top: 4px;
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  gap: 4px;
}

.field-constraints {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.6);
}

.constraint {
  display: flex;
  align-items: center;
  gap: 4px;
}

.preview-input {
  opacity: 0.9;
}

.preview-input :deep(.v-input__slot) {
  min-height: 44px;
  cursor: default;
  background-color: #f5f7fa !important;
}
</style>
